<seds-form-field-core
  [label]="label"
  [iconName]="iconName"
  [iconPosition]="iconPosition"
  [warningColor]="warningColor"
  [sendedControl]="_control">
  <ng-content></ng-content>
</seds-form-field-core>
